const applyScheme = (scheme) => {
  if (scheme === "light") {
    document.documentElement.classList.remove("dark");
    document
      .querySelectorAll(".color-scheme-dark-icon")
      .forEach((el) => el.classList.remove("hidden"));
    document
      .querySelectorAll(".color-scheme-light-icon")
      .forEach((el) => el.classList.add("hidden"));
    localStorage.scheme = "light";
  } else {
    document.documentElement.classList.add("dark");
    document
      .querySelectorAll(".color-scheme-dark-icon")
      .forEach((el) => el.classList.add("hidden"));
    document
      .querySelectorAll(".color-scheme-light-icon")
      .forEach((el) => el.classList.remove("hidden"));
    localStorage.scheme = "dark";
  }
};

const initScheme = () => {
  if (
    localStorage.scheme === "dark" ||
    (!("scheme" in localStorage) &&
      window.matchMedia("(prefers-color-scheme: dark)").matches)
  ) {
    applyScheme("dark");
  } else {
    applyScheme("light");
  }
};

const toggleScheme = () => {
  if (document.documentElement.classList.contains("dark")) {
    applyScheme("light");
  } else {
    applyScheme("dark");
  }
};

// Expose globals for existing hooks/components that still call window.* helpers.
window.applyScheme = applyScheme;
window.initScheme = initScheme;
window.toggleScheme = toggleScheme;

// Initialize once on bundle load so dark/light classes are ready before interaction.
try {
  initScheme();
} catch (_error) {
  // Ignore storage or browser API edge-case errors.
}

const ColorSchemeHook = {
  mounted() {
    this.handleClick = () => toggleScheme();
    this.el.addEventListener("click", this.handleClick);
    this.init();
  },
  updated() {
    this.init();
  },
  destroyed() {
    if (this.handleClick) {
      this.el.removeEventListener("click", this.handleClick);
    }
  },
  init() {
    initScheme();
  },
};

export default ColorSchemeHook;
